import { STSlideSizeType } from '@tencent/slide-sdk-model';

export const SlideSizeType = {
    SLIDE_SIZE_4_3: 100, // 4:3
    SLIDE_SIZE_16_9: 101, // 16:9
    SLIDE_SIZE_CUSTOM: 102, // 自定义
} as const;
export type SlideSizeType = typeof SlideSizeType[keyof typeof SlideSizeType];

export interface ISlideSizeProps {
    slideWidth: number; // 幻灯片宽度
    slideHeight: number; // 幻灯片高度
    // 旧版本UI数据层使用的比例
    slideSizeType: SlideSizeType; // 幻灯片比例
    // OOXML的Slide页面尺寸，这个slideSizeType应该统一
    type?: STSlideSizeType;
}
